import { State } from 'src/types'
import { thumbOut } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/thumbAndWristBelt'
import { thumbIndexMiddleFinger } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/thumbIndexMiddleFinger'
import { middleRingFinger } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/middleRingFinger'
import { ringLittleFinger } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/ringLittleFinger'
import { firstBackLittleFinger } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/littleFinger'
import { indexFingerPad } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/fingerCoverOrPad/indexFingerPad'
import { edgeOfWrist } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/edge/edgeOfWrist'
import { hamidashiOfFirstBack } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/hamidashi/firstBack'
import { fingerHole } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/fingerHole'
import { firstBackStyleWristBelt } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/firstBackStyleWristBelt'

// ファーストバック モデル
export const firstBackStyleDrawer = async (ctx: CanvasRenderingContext2D, state: State): Promise<void> => {
  if (state.backStyle?.value !== 'firstBackStyle' && state?.baseModel?.backStyle !== 'firstBackStyle') return
  const isFingerPad = ['indexPad'].includes(state.fingerGuardType.value)
  const printLeatherTypeValue = state.printLeatherType?.value

  // 親指外
  await thumbOut(ctx, state.thumbOut.color, printLeatherTypeValue)
  // 親指内_人差し指_中指右
  await thumbIndexMiddleFinger(ctx, state.thumbIndexMiddle?.color, printLeatherTypeValue)
  // 中指左_薬指右
  await middleRingFinger(ctx, state.middleLeftRingRight?.color, printLeatherTypeValue)
  // 薬指左_小指右
  await ringLittleFinger(ctx, state.ringLeftLittleRight?.color, printLeatherTypeValue)
  // 小指外
  await firstBackLittleFinger(ctx, state.littleOut?.color, printLeatherTypeValue)
  // ハミダシ
  hamidashiOfFirstBack(ctx, state.hamidashi.color)
  // ファーストバックベルト
  firstBackStyleWristBelt(ctx, state.listBelt.color)
  // 指当て
  isFingerPad && indexFingerPad(ctx, state.indexCover.color, state.stitch.color)
  // 指穴実装
  fingerHole(ctx, state.linings.color, state.lace.color)
  // ヘリ革
  edgeOfWrist(ctx, state.edge.color, state.stitch.color)
}
